var map = {
	"./en/classroom-backend.json": [
		55325,
		5325
	],
	"./en/client.json": [
		86875,
		6875
	],
	"./en/learnerApp.json": [
		51566,
		1566
	],
	"./en/localization.json": [
		31408,
		1408
	],
	"./en/orders.json": [
		17147,
		7147
	],
	"./en/server.json": [
		5734,
		5734
	],
	"./en/shared.json": [
		11308,
		1308
	],
	"./en/ui-auth.json": [
		61396,
		1396
	],
	"./en/ui-components-classroom.json": [
		96442,
		6442
	],
	"./en/ui-components-contentful.json": [
		51591,
		8886
	],
	"./en/ui-components-shared.json": [
		23165,
		3165
	],
	"./en/ui-components-website.json": [
		24748,
		4748
	],
	"./en/ui-legacy-component-library.json": [
		42041,
		2041
	],
	"./en/ui-rich-text-editor.json": [
		70503,
		503
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 81577;
module.exports = webpackAsyncContext;